import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

const useUIStore = create(
  persist(
    (set, get) => ({
      // State
      darkMode: false,
      drawerOpen: false,
      drawerWidth: 220,
      isMobile: false,

      // Actions
      toggleDarkMode: () => {
        set(state => ({ darkMode: !state.darkMode }))
      },

      setDarkMode: (darkMode) => {
        set({ darkMode })
      },

      toggleDrawer: () => {
        set(state => ({ drawerOpen: !state.drawerOpen }))
      },

      setDrawerOpen: (open) => {
        set({ drawerOpen: open })
      },

      setIsMobile: (isMobile) => {
        set({ 
          isMobile,
          // Auto-close drawer on mobile
          drawerOpen: isMobile ? false : get().drawerOpen
        })
      },

      // Responsive drawer behavior
      handleDrawerToggle: () => {
        const { isMobile } = get()
        if (isMobile) {
          set(state => ({ drawerOpen: !state.drawerOpen }))
        } else {
          set(state => ({ drawerOpen: !state.drawerOpen }))
        }
      }
    }),
    {
      name: 'ui-storage',
      partialize: (state) => ({
        darkMode: state.darkMode,
        drawerOpen: state.drawerOpen
      })
    }
  )
)

export default useUIStore
